
import { defineComponent } from 'vue';

import RadioFilled from '@svg/radio-filled.svg';

export default defineComponent({
  name: 'AssessmentRadio',
  emits: ['click-answer'],
  components: {
    RadioFilled
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    // Used to reset model state on change
    currentQuestion: {
      type: String,
      default: ''
    },
    isActivityWidget: {
      type: Boolean,
      default: false
    },
    widgetId: {
      type: Number,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      radioModel: null as null | number,
      isFocused: false
    };
  },
  computed: {
    id(): number | string {
      if (this.isActivityWidget) {
        return `userSelectBottom-${this.widgetId}-${this.index}`;
      }
      return `assessment-question-${this.index}`;
    },
    name(): string {
      if (this.isActivityWidget) {
        return `userSelectBottom-${this.widgetId}`;
      }
      return 'assessmentQuestion';
    }
  },
  watch: {
    isSelected: {
      immediate: true,
      handler(value: boolean) {
        if (value) {
          this.radioModel = this.index;
        }
      }
    },
    index() {
      this.radioModel = this.index;
    },
    currentQuestion() {
      this.radioModel = null;
    }
  },
  methods: {
    toggleCheckbox() {
      this.$emit('click-answer', this.index);
    },
    inputFocused() {
      this.isFocused = true;
    },
    inputBlurred() {
      this.isFocused = false;
    }
  }
});
